import { useEffect, useRef } from "react";
import { initElement, removeElement } from "./utils";

const useTaos = () => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof window === 'undefined') return;

    // Проверяем ширину экрана
    const checkScreenWidth = () => window.innerWidth >= 1200;
    let isDesktop = checkScreenWidth();

    // Функция для управления анимацией
    const toggleAnimation = (enable) => {
      if (enable) {
        // Включаем анимацию
        if (element.hasAttribute('data-taos-offset')) {
          // Возвращаем сохраненный offset
          const savedOffset = element.getAttribute('data-taos-offset-saved');
          if (savedOffset) {
            element.setAttribute('data-taos-offset', savedOffset);
            element.removeAttribute('data-taos-offset-saved');
          }
        }
      } else {
        // Выключаем анимацию
        if (element.hasAttribute('data-taos-offset')) {
          // Сохраняем текущий offset и убираем его
          const currentOffset = element.getAttribute('data-taos-offset');
          element.setAttribute('data-taos-offset-saved', currentOffset);
          element.removeAttribute('data-taos-offset');
        }
        // Убираем класс анимации если он есть
        if (element.classList.contains('taos-animate')) {
          element.classList.remove('taos-animate');
        }
      }
    };

    // Получаем offset из data-атрибута
    const offset = parseInt(element.dataset.taosOffset || 0);
    
    // 1. Инициализация Taos
    if (isDesktop) {
      initElement(element);
    }

    // Функция проверки видимости с учетом offset (как в оригинальном Taos)
    const checkVisibility = () => {
      if (!isDesktop) return; // Не проверяем видимость на мобильных
      
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrollY = window.scrollY;
      
      const triggerPoint = windowHeight - offset;
      const shouldBeAnimated = rect.top < triggerPoint && rect.bottom > 0;

      if (shouldBeAnimated) {
        // Taos сам добавит класс через свой механизм
      } else {
        if (element.classList.contains('taos-animate')) {
          element.classList.remove('taos-animate');
        }
      }
    };

    // Обработчик изменения размера экрана
    const resizeHandler = () => {
      const newIsDesktop = checkScreenWidth();
      
      if (newIsDesktop !== isDesktop) {
        isDesktop = newIsDesktop;
        
        if (isDesktop) {
          // Включаем анимацию
          initElement(element);
          checkVisibility();
        } else {
          // Выключаем анимацию
          toggleAnimation(false);
        }
      } else {
        // Просто обновляем видимость если нужно
        checkVisibility();
      }
    };

    // Создаем наблюдатель за скроллом с throttle для производительности
    let ticking = false;
    const scrollHandler = () => {
      if (!ticking && isDesktop) {
        requestAnimationFrame(() => {
          checkVisibility();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Запускаем начальную проверку
    if (isDesktop) {
      checkVisibility();
    } else {
      toggleAnimation(false);
    }

    // Добавляем обработчики
    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', resizeHandler);

    // 3. Очистка
    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', resizeHandler);
      removeElement(element);
    };
  }, []);

  return ref;
};

export default useTaos;